import { Component, HostListener, ViewChild } from '@angular/core';
import { DialogService } from 'src/app/core/services/dialog.service';
import { GridCountDialogComponent } from 'src/app/shared/acv-grid/components/grid-count-dialog/grid-count-dialog.component';

@Component({
  selector: 'app-trip-assigned-details',
  templateUrl: './trip-assigned-details.component.html',
  styleUrls: ['./trip-assigned-details.component.scss']
})
export class TripAssignedDetailsComponent {
  @ViewChild('specialInstructionRef') specialInstructionRef: GridCountDialogComponent;
  
  private _visibility: boolean = false;
  private _title: string = 'Trip Assigned';
  private _date: string = new Date().toLocaleDateString();
  private _legActionName: string = 'Pick Up';
  checked: boolean = true;

  @HostListener('document:keydown.escape', ['$event'])
  onEscPressed() {
    if(this.dialogService.isTopMost(this)) {
      this.hide();
    }
  }

  constructor(
    private readonly dialogService: DialogService,
  ) { }

  get visibility() {
    return this._visibility;
  }

  get title() {
    return this._title;
  }

  get date() {
    return this._date;
  }

  get legActionName() {
    return this._legActionName;
  }

  set legActionName(name: string) {
    this._legActionName = name;
  }

  set date(date: string) {
    this._date = date;
  }

  setTitle(title: string) {
    this._title = title;
  }

  show() {
    this._visibility = true;
    this.dialogService.registerDialog(this);
  }

  hide() {
    this._visibility = false;
    this.dialogService.unregisterDialog(this);
  }

  onViewClick(instruction: string[]) {
    this.specialInstructionRef.title = 'Special Instructions';
    this.specialInstructionRef.data = instruction;
    this.specialInstructionRef.show();
  }
}
